import type { CarrierService } from './index';
import * as fixtures from './fixtures';
import type { CarrierRateSelectionResponseMap } from './types';
import uuid from 'uuid-random';

import type { RateCalculationTestRequest } from './types';
import { mockShipmentResponse } from '../ShiptimeService/fixtures';
import delay from '../mockServiceDelay';
import type { CarrierCurrencyConversionResult, CarrierCurrencyRateResponseV1 } from '@shipium-corp/shipium-ts-types';

export const mockCarrierService: CarrierService = {
  carrierRateSelectionTest: async (request: RateCalculationTestRequest) => {
    await delay();
    const key = uuid();
    const record: CarrierRateSelectionResponseMap = {};
    record[key] = {
      key,
      status: 200,
      carrierSelection: fixtures.mockCarrierRateCalculationResponse,
      shipment: mockShipmentResponse,
    };
    return record;
  },
  megaMethodTest: async (request: RateCalculationTestRequest) => {
    await delay();
    return fixtures.mockCarrierRateCalculationResponse;
  },
  bulkCarrierRateSelectionTest: async (request: any) => {
    await delay();
    return request;
  },
  fetchExpiringRates: async (payload) => {
    await delay();
    return [];
  },
  getFedexHubIds: async () => {
    await delay();
    return [
      {
        code: 'PHL',
        hubId: '5251',
        location: 'Philadelphia,PA',
      },
    ];
  },
  previewZipZones: async () => {
    await delay();
    return fixtures.mockZonePreviewResponse;
  },
  applyZipZonePreview: async () => {
    await delay();
    return fixtures.mockZonePreviewResponse;
  },
  fetchUsedV2Carriers: async () => {
    await delay();
    return {};
  },
  fetchUpsVerifyOptions: async () => {
    await delay();
    return {};
  },
  saveUpsVerifyAuthCode: async (payload) => {
    await delay();
    return [];
  },
  fetchUpsVerifyAuthCode: async () => {
    await delay();
    return [];
  },
  deleteUpsVerifyAuthCodes: async () => {
    await delay();
    return [];
  },
  fetchServiceMethods: async () => {
    return [] as any;
  },
  fetchServiceMethod: async () => {
    const usps = fixtures.carriers.find((c) => c.carrierId === 'usps');
    const pselect = usps?.serviceMethods.find(
      (mtd: any) => mtd.serviceMethodId === 'usps-parcel-select-service-method',
    );
    return { carrierId: usps?.carrierId, serviceMethodInfo: pselect } as any;
  },
  createPartnerServiceMethod: async () => {
    return {} as any;
  },
  fetchCurrencyConversionRates: async () => {
    return {} as CarrierCurrencyRateResponseV1;
  },
  fetchCurrencyConversion: async () => {
    return {} as CarrierCurrencyConversionResult;
  },
};
